import { format as formatWithTimezone } from "date-fns-tz";

const CONDENSED_DATETIME_FORMAT = "d MMM yyyy 'at' h:mm a z";

/**
 * Format the date time in its condensed form.
 *
 * ✅ This is part of the Cadmus standardised date/duration formatting.
 *
 * {@link https://docs.google.com/spreadsheets/d/1XO8M5bPTAd-uVWCaygIGt9ch1BDOtZCV2zHZxPNtmbg/edit#gid=21065173 Style guide}
 * @example formatCondensedDateTime(new Date("2021-08-21T14:52:24.460000"))
 * // returns "21 Aug 2021 at 2:52 PM UTC"
 */
export const formatCondensedDatetime = (date: Date): string => {
  return formatWithTimezone(date, CONDENSED_DATETIME_FORMAT);
};
